module.exports = __webpack_public_path__ + "static/EuclidCircularB-Semibold-WebS-2f461fc2fd4cf4cdfafce867ae7d518c.woff";